import rawUiExport from './ui_export.json' with { type: 'json' };
import { normalizeToolRecord } from './normalizeContent.js';

const exportedAt = rawUiExport.exported || rawUiExport.sync_metadata?.exported || '';

export const uiExport = {
  ...rawUiExport,
  tools: (rawUiExport.tools || []).map((tool) => normalizeToolRecord(tool, exportedAt)),
};

export default uiExport;
